import type { DemandMatrixRow } from '@erp/rpc';
import type { DemandDetailSearch, DemandSearch } from '../demand/demandFilters';

type RecordIdentity = Pick<DemandMatrixRow, 'sku' | 'warehouseId'>;

export function recordNeighbor(
  rows: readonly RecordIdentity[],
  index: number,
  direction: -1 | 1,
  adjacentRows?: readonly RecordIdentity[],
): RecordIdentity | undefined {
  if (index < 0) return undefined;
  const neighborIndex = index + direction;
  if (neighborIndex >= 0 && neighborIndex < rows.length)
    return rows[neighborIndex];
  return direction === -1 ? adjacentRows?.at(-1) : adjacentRows?.[0];
}

/**
 * The detail search for one row of a list. Legacy and rolled-up rows cannot
 * identify one editable item/location, so they have none.
 *
 * `list` is the grid search being walked. Its filters travel unchanged — the
 * row's location is the item's own `warehouseId`, not a narrowing of them — so
 * the next step walks the same list.
 */
export function recordDestination(
  row: RecordIdentity | undefined,
  rowIndex: number,
  list: DemandSearch,
  runId: string | null | undefined,
  fallbackRunId?: string,
): DemandDetailSearch | null {
  if (rowIndex < 0 || !row?.sku || !row.warehouseId) return null;
  return {
    ...list,
    sku: row.sku,
    warehouseId: row.warehouseId,
    rowIndex,
    navigationRunId: runId ?? fallbackRunId,
  };
}
